import type { Transaction } from '@shared/transactions-types';

import { getRouteToProductRoot } from './getRouteToProductRoot';

export function getRouteToTransactionsHistory(transaction: Transaction): string | undefined {
    const root = getRouteToProductRoot(transaction);
    return root && `${root}/details/transactions`;
}
